import { connect } from "react-redux";
import RealtimeDashboard from "../../Components/RealtimeDashboard/RealtimeDashboard";

const mapStateToProps = (state) => ({
  queues: state.reducer.QUEUES,
  agents: state.reducer.AGENTS,
  scopes: state.reducer.SCOPES,
});

const mapDispatchToProps = (dispatch) => ({
  // Add dispatch actions here if needed
});

export default connect(mapStateToProps, mapDispatchToProps)(RealtimeDashboard);
